// 多語言標籤：zh_CN.js
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW'

const zhTW = {
  ...zhTWLocale,
  PUB: {
    lyods: '莱斯工程有限公司',
    home: '首頁',
    name: '名稱',
    lang: '語言',
    admin: '系統管理員',
    login: '登錄',
    tenantId: '租戶號',
    userRole: '用戶角色',
    reLogin: '重新登錄',
    logining: '登錄中...',
    logout: '退出登錄',
    logoutTips: '確定註銷并退出系統嗎？',
    loginName: '登錄名稱',
    password: '密碼',
    resetPwd: '重置密碼',
    code: '驗證碼',
    retrieve: '找回密碼',
    copyright: '版權所有',
    rememberMe: '記住我',
    fogertPwd: '忘記密碼',
    cancelMail: '取消所有郵件',
    inputContent: '請輸入內容',
    pleSelect: '請選擇',
    pleMultiSelect: '多個值，以“,”分隔',
    inputMultiContent: '多個值，分隔為：',
    selectDate: '選擇日期',
    selectTime: '選擇時間',
    selectDateTime: '選擇日期時間',
    loading: '加載中...',
    ok: '確定',
    cancel: '取消',
    return: '返回',
    tips: '提示',
    sysTips: '系統提示',
    person: '個人中心',
    layout: '佈局設置',
    layoutSize: '佈局大小',
    search: '查詢',
    add: '新增',
    upd: '修改',
    del: '刪除',
    view: '查看',
    copy: '複製',
    imp: '導入',
    exp: '導出',
    auth: '授權',
    nonselected: '請先選擇要操作的記錄',
    warn: '警告',
    confirmDelete: '確定要刪除此記錄?',
    confirmSession: "此記錄為當前用戶，確認繼續刪除？",
    cancelOper: '已取消當前操作',
    confirmPwd: '確認密碼',
    email: '電子郵箱',
    phone: '電話',
    mobile: '流動電話',
    fax: '傳真',
    address: '地址',
    status: '狀態',
    normal: '正常',
    invalid: '作廢',
    checkAll: '全選',
    field: '字段',
    oper: '比較符',
    searchVal: '條件值',
    action: '操作',
    sort: '排序',
    unit: '部門',
    unitGrp: '部門組',
    refresh: '刷新頁面',
    closeOth: '關閉其他',
    closeCurr: '關閉當前',
    closeAll: '關閉所有',
    show: '顯示',
    fixed: '固定',
    open: '開啟',
    sysLayout: '系統佈局配置',
    themeColor: '主題顏色',
    reset: '重置',
    oldPwd: '原密碼',
    newPwd: '新密碼',
    sercurity: '安全設置',
    download: '下載',
    minute: '分',
    hour: '時',
    day: '天',
    month: '月',
    week: '週',
    today: '今天',
    yesterday: '昨天',
    aWeekAgo: '一周前',
    close: '關閉',
    newVal: '新數據',
    oldVal: '舊數據',
    label: '標籤名稱',
    content: '內容',
    chgDetails: '變更詳情',
    reloadLic: '重新加載許可證',
    remark: '備註',
    reject: '拒絕',
    color: '顏色',
    upload: '上傳',
    uploadClick: '點擊上傳',
    uploadMax: '超過文件上傳的最大個數',
    uploadDrag: '將文件拖到此處，或',
    uploadFormatError: '文件格式不正確，請重新上傳',
    uploadImg: '文件格式錯誤，請上傳圖片類型，如:JPG，PNG後綴的文件',
    uploadMaxSize: '上傳文件大小超過限制',
    downTmpl: '下載模板',
    xlsOrXlsx: '僅允許導入“xls”或“xlsx”格式文件！',
    removeConfirm: '確定移除',
    chgFileDown: '變更文件下載',
    Mon: '星期壹',
    Tues: '星期二',
    Wed: '星期三',
    Thur: '星期四',
    Fri: '星期五',
    Sat: '星期六',
    Sun: '星期日',
    total: '顯示總數',
    mandatory: '必輸',
    allowValue: '允許值',
    txt: '僅允許導入“txt”格式文件',
    expExcel: '導出Excel文件',
    //Camera
    noFrontCamera: "您的設備上似乎冇前置攝像頭",
    noRearCamera: "您的設備上似乎冇后置攝像頭",
    startDate: '開始日期',
    endDate: '結束日期',
    noticeUnit: '需要通知的部門',
    help: "幫助",
    variable: "變量"
  },
  http: {
    401: '未授權',
    404: '頁面不存在',
    500: '系統內部錯誤'
  },
  valid: {
    required: '必須填寫',
    number: '必須為數字值',
    addSearch: '請添加查詢條件',
    sameSearch: '該字段已經存在相同比較答的條件，請勿重複添加',
    nonChgView: '當前視圖無任何變更，無需保存！',
    selColumn: '至少選擇一列',
    addView: '還有視圖未保存，是否新增視圖？',
    saveView: '確定要保存當前視圖的操作？',
    selected: '至少選擇一個選項',
    unitGrp: '部門組和部門必須有一個要選擇',
    unit: '部門至少要選擇一個',
    cpwd: '請再次輸入密碼',
    ncpwd: '兩次輸入密碼不一致',
    email: '請輸入有效的電郵',
    mobile: '請輸入正確的手機號',
    selRole: '角色必須選擇',
    rqlang: '字典語言和字典值必須填寫',
    dblang: '已經存在相同字典語言',
    pwdValidError: '密碼必須包括如下內容：',
    length: '長度',
    letters: '字母',
    digits: '數字',
    specialCharracters: '特殊字符',
    containSensitive: '大小寫字母',
    selMenu: '菜單必須選擇',
    formatErr: '格式不正確',
    trueOrFalse: '值必須為true或false',
    unPerm: '無對應操作權限',
    uploadFile: '請先上傳文件',
    selUnitGrp: '至少選擇壹個部門組',
    extEmpty: '請選擇擴展功能',
    extExists: '已存在相同擴展功能',
    extLen: '長度必須小於',
    min: '最小值為：',
    max: '最大值為：',
    range: '請輸入介於 {0} 和 {1} 之間的數值'
  },
  view: {
    add: '新增視圖',
    upd: '修改視圖',
    del: '刪除視圖',
    name: '視圖名稱',
    column: '視圖列',
    confirmDel: '確定要刪除當前視圖？',
    confirmDefView: '確定要將當前視圖設置為默認視圖嗎？',
    save: '保存視圖',
    share: '共享視圖',
    defView: '默認視圖',
    priView: '私有視圖',
    priViewDes: '私有視圖僅自己可見',
    pubView: '公有視圖',
    pubViewDes: '將此設定為默認的公共視圖，所有人可見',
    roleView: '角色視圖',
    roleViewDes: '在下面選擇相關的角色可以看到的視圖'
  },
  oper: {
    eq: '等於',
    ne: '不等於',
    starWith: '開始於',
    endWith: '結束於',
    contains: '包含',
    bigger: '大於',
    less: '小於',
    biggerThan: '大於等於',
    lessThan: '小於等於',
    before: '以前',
    after: '以後',
    lastDay: '最近一天',
    lastWeek: '最近一週',
    lastMonth: '最近一個月',
    last3Month: '最近三個月',
    last6Month: '最近六個月',
    lastYear: '最近一年',
    no: '不在',
    yes: '在',
    ltToday: '小於今天',
    leToday: '小於等於今天',
    gtToday: '大於今天',
    geToday: '大於等於今天'
  },
  role: {
    add: '新增角色',
    upd: '修改角色',
    view: '查看角色',
    del: '刪除角色',
    name: '角色名稱',
    desc: '角色描述',
    menu: '菜單選擇',
    assignRole: '可分配角色',
    select: '已選角色',
    expEncodeFile: '導出加密文件',
    rtn: '實時檢測郵件通知',
    btn: '批量檢測郵件通知'
  },
  user: {
    add: '新增用戶',
    upd: '修改用戶',
    view: '查看用戶',
    del: '刪除用戶',
    resetinf: '密碼重置為：'
  },
  unit: {
    add: '新增部門',
    upd: '修改部門',
    view: '查看部門',
    del: '刪除部門',
    code: '部門代號',
    desc: '部門名稱'
  },
  codeDtl: {
    add: '新增參數',
    upd: '修改參數',
    view: '查看參數',
    del: '删除參數',
    refMasterCode: '主代碼',
    refCode: '代碼',
    refDesc: '描述'
  },
  unitGrp: {
    add: '新增部門組',
    upd: '修改部門組',
    view: '查看部門組',
    del: '删除部門組',
    name: '部門組名稱',
    desc: '部門組描述',
    exp1: 'EXP',
    assignUnitGrp: '可選部門組',
    selectUnitGrp: '已選部門組',
    assignUnit: '可選部門',
    selectUnit: '已選部門'
  },
  dic: {
    add: '新增字典',
    upd: '修改字典',
    del: '刪除字典',
    view: '查看字典',
    hkey: '字典名稱',
    pkey: '父級字典',
    code: '代碼',
    desc: '描述'
  },
  cron: {
    add: '新增任務',
    upd: '修改任務',
    del: '刪除任務',
    view: '查看任務',
    hkey: '任務名稱',
    func: '功能描述',
    executeTime: 'Cron執行表達式',
    execStatus: '執行狀態',
    concurrent: '允許并發',
    lastExecDate: '最後執行時間',
    nextExecDate: '下一執行時間',
    lastRunResult: '最後執行結果',
    ap1: ', - * /',
    ap2: ', - * ? / L',
    ap3: ', - * ? / L #',
    sp1: '使用星號（*）指示着你想在這個域上包含所有合法的值，例如，在月份域上使用星號意味着每個月都會觸發這個trigger。表達式樣例：0*17**？意義：每天從下午5點到下午5：59中的每一分激發一次trigger。',
    sp2: '問號只能用在日和周域上，但是不能在這兩個域上同時使用。你可以認爲？字符是”我並不關心在該域上是什麼值。“這不等於星號，星號是指示着該域上的每一個值。？是說不爲該域指定值。表達式樣例：0 10,44 14 ? 3 WEB，意義：在三月中的每個星期三的下午2：10和2：44被觸發。',
    sp3: '逗號（，），是用來在給某個域上指定一個值列表的，例如，使用值0，15,30,45，在秒域上意義着每15秒觸發一個trigger.',
    sp4: '斜槓是用於時間表的遞增的。表達式樣例:0/15 0/30 * * * ?意義：在整點和半點時每15秒觸發trigger。',
    sp5: '中劃線（-）用於指定一個範圍。表達式樣例：0 45 3-8 ? * *意義：在上午的3點至上午的8點的45分時觸發trigger.',
    sp6: '"L"說明了某域上的允許的最後一個值。他僅被日和周域支持。當用在日域上，表示的是在月域上指定的月份的最後一天。表達式0 0 8 L * ? 意義是在每個月最後一天的上午8:00觸發trigger。在月域上的*說明是”每個月“。',
    sp7: '字符(#)僅能用於周域中。它用於指定月份中的第幾周的那一天。例如，如果你指定周域的值爲：6#3，她意思是某月的第第三個週五（6=星期五，#3意味着月份中的第三週）。另一個例子，2#1意思是某月的第一個星期一（2=星期一，#1意味着月份中的第一週）。注意，假如你指定#5，然而月份中沒有第五週，那麼該月不會觸發。'
  },
  atlog: {
    view: '查看審計日誌',
    operTime: '操作日期',
    operHost: '操作主機',
    permission: '功能模塊'
  },
  userInfo: {
    avatar: '修改頭像',
    baseData: '基本資料',
    updUserData: '用戶資訊',
    updUserPwd: '用戶密碼控制'
  },
  mailSuccess: {
    notice1: '郵件發送成功',
    notice2: '　　系統已將重置密碼的鏈接安全的發送到你的郵箱 ',
    notice3: ' ，請及時查收。并在 24 小時內完成重置密碼操作。',
    notice4: '　　還沒有收到郵件？點擊 [ ',
    notice5: '找回密碼',
    notice6: ' ] 重試。'
  },
  msgTmpl: {
    add: '新增消息模板',
    upd: '修改消息模板',
    view: '查看消息模板',
    hdrKey: '模板類型',
    defFlag: '是否爲默認',
    tmplTitle: '模板標題',
    tmplContent: '模板内容'
  },
  alertMsg: {
    add: '新增系統通知',
    del: '刪除系統通知',
    upd: '修改系統通知',
    view: '查看系統通知'
  },
  holiday: {
    info: '假日詳情',
    hdate: '日期',
    isHoliday: '是否假期',
    hdateDesc: '描述',
    addArrange: '新增假日安排',
    updArrange: '修改假日安排',
    add: '新增假日',
    upd: '修改假日',
    holiday: '假日',
    workingDay: '工作日',
    toVoid: '作廢',
    countryCode: '國家/地區',
    startDate: '開始日期',
    endDate: '結束日期',
    selectMonth: '選擇月',
    nonselected: '請先選擇國家/地區代碼或日期範圍',
    weekend: '周末'
  },
  userLogin: {
    add: '新增登錄控制',
    upd: '修改登錄控制',
    view: '查看登錄控制',
    byDay: '按天',
    byWeekend: '按周',
    nonselected: '請勾選周期',
  },
  mclient: {
    add: '新增客戶資訊',
    upd: '修改客戶資訊',
    view: '查看客戶資訊',
    lyodsVersion: '版本號',
    onlyKey: "僅允許導入“key”格式文件！",
    company: '公司',
    site: '城市',
    project: '項目名稱',
    platform: '操作系統',
    func: '功能模塊',
    maxUser: '最大在線用戶數',
    expiration: '有效日期',
    licInfo: '證書資訊',
    logo: '客戶標識',
    sysInfo: '系统資訊',
    updSysInfo: '系统資訊维护'
  },
  apiKeys: {
    add: '新增API密鑰',
    del: '刪除API密鑰',
    upd: '修改API密鑰',
    view: '查看API密鑰',
    create: '創建 UUID',
    illegalChar: '不允許有特殊字符',
  },
  decStates: {
    add: '新增狀態',
    upd: '修改狀態',
    del: '刪除狀態',
    view: '查看狀態'
  },
  project: {
    add: '新增項目資訊',
    upd: '修改項目資訊',
    del: '刪除項目資訊',
    view: '查看項目資訊',
    inputNative: "請輸入中文內容",
    inputEn: "請輸入英文內容",
    contentNative: '中文內容',
    contentEn: '英文內容',
    minAmt: '最小金額',
    donateTypeDic: '支持方式字典',
    ticketFlag: '涉及門票',
    donateTypeFlag: '顯示支持方式',
    maxTicket: '最大票數',
    briefForm: '簡潔表單',
    dinfoExtExist: '該項目已在捐款記錄中被引用,取消涉及門票和顯示支持方式將會刪除對應捐款記錄部分數據',
    workshop: '研討會',
  },
  donate: {
    add: '新增記錄',
    upd: '修改記錄',
    view: '查看記錄',
    pjId: '捐款項目',
    nameEn: '英文姓名',
    nameNative: '中文姓名',
    alias: '別名',
    gender: '性別',
    telephone: '電話',
    mobile: '流動電話',
    email: '電郵',
    address: '郵寄地址',
    dnMethods: '捐款方法',
    currency: '貨幣',
    amount: '金額',
    valDate: '捐款日期',
    status: '確認狀態',
    refNo: '參考號',
    submitIp: 'IP地址',
    referrer: '推薦人',
    certificate: '捐款憑證',
    confirm: '確認',
    repeat: '重複',
    invalid: '無效',
    refNoNoNull: '確認時需填寫銀行參考號',
    donateType: '支持方式',
    ticketType: '出席方式',
    ticketSeq: '票號',
    ticketCode: '門票二維碼',
    ticketCheckin: '門票是否已檢錄',
    ticketChkchop: '檢錄時間及用戶'
  },
  uheart: {
    selLang: '選擇語言',
    project: '項目',
    register: '捐款登記',
    recentDonates: '近期捐款記錄',
    statistics: '捐款統計資訊',
    info: '捐款資料',
    formTitle: '捐款/贊助表格',
    formTitle1: '捐助項目',
    formTitle2: '捐助人/機構資料',
    formTitle3: '捐款方法',
    formSubtitle: '本人捐助登記',
    dnMethods: '銀行直接存款/自動柜員機轉帳',
    upload: '上載付款紀錄',
    uploadTips: '上傳只接收jpg/png檔案',
    uploadFormatErr: '上傳檔案只能是圖片格式!',
    uploadRequired: '必須上傳付款紀錄',
    submit: '提交',
    allEvents: '所有活動',
    note: '捐款流程注意事項：',
    tips: '閣下之捐款需經本會確認後方為有效。如有問題，本會將透過電話或電郵聯絡。',
    refTaxTips: '捐款HK$100或以上者，均可獲發收據，作扣稅用途。收據姓名須根據身份證或護照填寫中文或英文全名。如需收據，請填寫郵寄地址。',
    point: '聯系人',
    phone: '聯系電話',
    email: '聯系郵箱',
    events: '最新活動',
    title: '研討會登記',
    capture: '截屏',
    onsite: '現場',
    webinar: '網絡',
    leftTicket: '剩餘票數',
    send: '遞交',
    ticketType: '參與方式',
  },
  ticket: {
    check: '檢錄',
    total: '門票總數',
    startDate: '開始時間',
    checkCount: '已檢錄數',
    uncheckCount: '未檢錄數',
    history: '檢錄歷史',
    qrCode: '二維碼',
    welcome: '歡迎！',
    invalid: '確認通知書編碼格式不正確',
    view: '查看門票檢錄'
  },
  emailLog: {
    view: '查看郵件日志',
  },
}

export default zhTW



// WEBPACK FOOTER //
// ./src/assets/lang/zh_TW.js